import { render, staticRenderFns } from "./achievementList.vue?vue&type=template&id=7ca19d6b&scoped=true"
import script from "./achievementList.vue?vue&type=script&lang=js"
export * from "./achievementList.vue?vue&type=script&lang=js"
import style0 from "./achievementList.vue?vue&type=style&index=0&id=7ca19d6b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca19d6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ca19d6b')) {
      api.createRecord('7ca19d6b', component.options)
    } else {
      api.reload('7ca19d6b', component.options)
    }
    module.hot.accept("./achievementList.vue?vue&type=template&id=7ca19d6b&scoped=true", function () {
      api.rerender('7ca19d6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/details/comps/achievementList.vue"
export default component.exports